import {useNavigate, useParams} from "react-router-dom";
import {Alert, Card, CardContent, CircularProgress, Typography} from "@mui/material";
import SnackError from "../../components/SnackError";
import React from "react";
import {ProfileApiGet, useGetProfileByIdQuery, usePutProfileByIdMutation} from "./users_api";
import ProfileForm from "./UserForm";
import {pick} from "../../../supabase/functions/_shared/types/eracuni";
import {useGetPersonQuery} from "../people/people_api";


export const UserEdit = () => {

    const {id} = useParams<"id">()
    const {data, isFetching} = useGetProfileByIdQuery({
        id: id!
    });
    const {data: workers} = useGetPersonQuery({active: true});
    const [put, {
        isLoading: isUpdating,
        error,
        isError,
    }] = usePutProfileByIdMutation();
    const navigate = useNavigate();
    const params = useParams<"id">();

    const handleSubmit = async function (values: ProfileApiGet) {

        const body = pick(values, ["fullName", "defaultWorkerID"]);
        body.defaultWorkerID = values.worker?.id || null;
        const res = await put({id: params.id || "", body, roles: values.userRoles?.roles})
        if ("data" in res) {
            navigate("..")
        }
    };
    if (!data || isFetching)
        return <CircularProgress/>;

    if (!workers) return <CircularProgress/>;

    if (!data) return <Alert severity={"error"}>Not found</Alert>

    return <Card sx={{mt: "2em"}}>
        <CardContent>
            <Typography variant={"h1"}>{data && data.fullName}</Typography>
        </CardContent>
        {isError && <SnackError error={error}/>}
        <ProfileForm
            isUpdating={isUpdating}
            onSubmit={handleSubmit}
            workers={workers}
            onCancel={() => navigate("..", {replace: true})}
            object={data}
        />
    </Card>;
}
